import { ConnectionsModal } from "components/Connections/ConnectionsModal";
import Modal from "components/DesignSystem/Modal/Modal";
import { LockSecure } from "components/icons/LockSecure";
import React from "react";
import { ManualBank } from "types/Models/banks";

/**
 * @param {string} [props.entityIdFromParent] - Pass entityIdFromParent if url query params don't have entity.
 */
export const BankConnectModal = ({
  entityIdFromParent,
  isOpen,
  close,
  onConnect,
  onManualBankAddSuccess,
  onComplete,
}: {
  isOpen: boolean;
  close: () => void;
  onConnect: ({ connectionId }: { connectionId: string }) => void;
  onManualBankAddSuccess?: (bank: ManualBank) => void;
  onComplete?: () => void;
  entityIdFromParent?: string;
}) => {
  return (
    <>
      <Modal.Root open={isOpen} onOpenChange={close}>
        <Modal.Content size="large" useCustomOverlay>
          <Modal.Header>
            <Modal.Title>Connect</Modal.Title>
            <Modal.Close />
          </Modal.Header>
          <Modal.Body>
            <ConnectionsModal
              onConnect={onConnect}
              onComplete={onComplete}
              onManualBankAddSuccess={onManualBankAddSuccess}
              entityIdFromParent={entityIdFromParent}
            />
          </Modal.Body>
          <Modal.Footer>
            <div className="t-flex t-items-center t-gap-3">
              <div>
                <LockSecure />
              </div>
              <p className="t-m-0 t-text-text-30 t-text-body-sm">
                Inkle connects your account securely in compliance with industry
                standards. Inkle will only have read-only access to your
                transactions.
              </p>
            </div>
          </Modal.Footer>
        </Modal.Content>
      </Modal.Root>
    </>
  );
};
